﻿export default `阿姨	阿姨	a1yi2	āyí	auntie; step-mother; mother's younger sister	
啊	啊	a5	a	ah; (particle showing elation, doubt, puzzled surprise, or approval)	
矮	矮	ai3	ǎi	short; low	
爱好	愛好	ai4hao4	àihào	hobby; fond of; to like; interest	
安静	安靜	an1jing4	ānjìng	quiet; peaceful; calm	
把	把	ba3	bǎ	(mw for things with handles); (pretransitive particle); to hold	
班	班	ban1	bān	team; class; squad	
搬	搬	ban1	bān	to move; to transport	
办法	辦法	ban4fa3	bànfǎ	method; way (of doing something)	
办公室	辦公室	ban4gong1shi4	bàngōngshì	office	
半	半	ban4	bàn	half; semi-; incomplete	
帮忙	幫忙	bang1mang2	bāngmáng	to help	
包	包	bao1	bāo	to cover; to wrap; to hold; include; (mw for containers, packages, etc.)	
饱	飽	bao3	bǎo	eat until full; satisfied	
北方	北方	bei3fang1	běifāng	north; the northern part of the country	
被	被	bei4	bèi	by (indicates passive voice sentences); a quilt/blanket	
鼻子	鼻子	bi2zi5	bízi	nose	
比较	比較	bi3jiao4	bǐjiào	compare; contrast; relatively	
比赛	比賽	bi3sai4	bǐsài	(sports) match; competition	
笔记本	筆記本	bi3ji4ben3	bǐjìběn	notebook	
必须	必須	bi4xu1	bìxū	must; have to	
变化	變化	bian4hua4	biànhuà	change	
别人	別人	bie2ren5	biéren	other people; others	
冰箱	冰箱	bing1xiang1	bīngxiāng	refrigerator	
不但	不但	bu2dan4	búdàn	not only	
而且	而且	er2qie3	érqiě	moreover; in addition; as well as	
菜单	菜單	cai4dan1	càidān	menu	
参加	參加	can1jia1	cānjiā	participate; join; take part in	
草	草	cao3	cǎo	grass; straw; draft (of a document)	
层	層	ceng2	céng	(mw for layers, floors of buildings)	
差	差	cha4	chà	differ from; fall short of; poor; inferior
超市	超市	chao1shi4	chāoshì	supermarket	
衬衫	襯衫	chen4shan1	chènshān	shirt; blouse	
成绩	成績	cheng2ji4	chéngjì	achievement; success; results (of work or study)	
城市	城市	cheng2shi4	chéngshì	city or town	
迟到	遲到	chi2dao4	chídào	arrive late	
除了	除了	chu2le5	chúle	besides; except for; aside from; in addition to	
船	船	chuan2	chuán	a boat; vessel; ship	
春	春	chun1	chūn	spring (season); joyful	
词典	詞典	ci2dian3	cídiǎn	dictionary	
聪明	聰明	cong1ming5	cōngming	intelligent; clever; bright; smart	
打扫	打掃	da3sao3	dǎsǎo	to clean; to sweep	
打算	打算	da3suan4	dǎsuàn	to plan; intend	
带	帶	dai4	dài	band; belt; ribbon; carry; bring; take along; bring up (kids)	
担心	擔心	dan1xin1	dānxīn	to worry; feel anxious	
蛋糕	蛋糕	dan4gao1	dàngāo	cake	
当然	當然	dang1ran2	dāngrán	of course; naturally	
地	地	di4, de5	dì, de	earth; ground | (adverbial particle)	
灯	燈	deng1	dēng	lamp; light	
地方	地方	di4fang5	dìfang	place; space; room; part, (fāng: local; regional)	
地铁	地鐵	di4tie3	dìtiě	subway	
地图	地圖	di4tu2	dìtú	map	
电梯	電梯	dian4ti1	diàntī	elevator	
电子邮件	電子郵件	dian4zi3 you2jian4	diànzǐ yóujiàn	email	
东	東	dong1	dōng	East	
冬	冬	dong1	dōng	winter	
动物	動物	dong4wu4	dòngwù	animal	
短	短	duan3	duǎn	short (in length, duration, or height); lack	
段	段	duan4	duàn	paragraph; segment; section	
锻炼	鍛煉	duan4lian4	duànliàn	to exercise; work out; toughen; to temper	
多么	多麼	duo1me5	duōme	how (wonderful, etc.); what (a great idea)	
饿	餓	e4	è	hungry	
耳朵	耳朵	er3duo5	ěrduo	ear	
发	發	fa1, fa4	fā, fà	send out; to issue; to show (one's feelings) | hair	
发烧	發燒	fa1shao1	fāshāo	have a fever	
发现	發現	fa1xian4	fāxiàn	discover; to find	
方便	方便	fang1bian4	fāngbiàn	convenient	
放	放	fang4	fàng	put; to place; to release; to free	
放心	放心	fang4xin1	fàngxīn	relax; feel relieved; rest assured	
分	分	fen1, fen4	fēn, fèn	divide; part; minute; cent | component; share; ingredient	
附近	附近	fu4jin4	fùjìn	(in the) vicinity; nearby; neighboring	
复习	復習	fu4xi2	fùxí	revise; to review	
干净	干淨	gan1jing4	gānjìng	clean; neat and tidy	
感冒	感冒	gan3mao4	gǎnmào	catch cold; (common) cold	
感兴趣	感興趣	gan3 xing4qu4	gǎn xìngqù	be interested in	
刚才	剛才	gang1cai2	gāngcái	just now; a moment ago	
个子	個子	ge4zi5	gèzi	height; stature; build	
根据	根據	gen1ju4	gēnjù	according to; based on; basis	
跟	跟	gen1	gēn	to follow; go with; heel	
更	更	geng4	gèng	more; even more
公斤	公斤	gong1jin1	gōngjīn	kilogram	
公园	公園	gong1yuan2	gōngyuán	public park	
故事	故事	gu4shi5	gùshi	story; tale	
刮风	刮風	gua1feng1	guāfēng	windy; to blow (wind)	
关	關	guan1	guān	to close; shut; concern; relationship; turn off; mountain pass	
关系	關系	guan1xi5	guānxi	relation; to concern	
关心	關心	guan1xin1	guānxīn	concerned about/with	
关于	關於	guan1yu2	guānyú	about; regarding; concerning	
国家	國家	guo2jia1	guójiā	country; state; nation	
过	過	guo4	guò	to pass; to cross; go over; (indicates a past experience)	
过去	過去	guo4qu4	guòqù	in the past; formerly	
还是	還是	hai2shi5	háishi	or; still; nevertheless; had better	
害怕	害怕	hai4pa4	hàipà	afraid of; to fear	
黑板	黑板	hei1ban3	hēibǎn	blackboard	
后来	后來	hou4lai2	hòulái	afterwards; after; later	
护照	護照	hu4zhao4	hùzhào	passport	
花	花	hua1	huā	flower; blossom; spend money; cost	
画	畫	hua4	huà	draw; picture; painting	
坏	壞	huai4	huài	bad; broken	
欢迎	歡迎	huan1ying2	huānyíng	to welcome; greet	
还	還	hai2	hái	still; yet; in addition; even	
环境	環境	huan2jing4	huánjìng	environment; surroundings	
换	換	huan4	huàn	change; to exchange; to barter; to trade	
黄河	黃河	huang2he2	huánghé	Yellow River	
回答	回答	hui2da2	huídá	to reply; to answer	
会议	會議	hui4yi4	huìyì	meeting; conference	
或者	或者	huo4zhe3	huòzhě	or; possible; maybe; perhaps	
几乎	幾乎	ji1hu1	jīhū	almost	
机会	機會	ji1hui4	jīhuì	opportunity; chance; occasion	
极	極	ji2	jí	an extreme; pole; very	
记得	記得	ji4de5	jìde	remember	
季节	季節	ji4jie2	jìjié	season; time; period	
检查	檢查	jian3cha2	jiǎnchá	to check; examine; inspect	
简单	簡單	jian3dan1	jiǎndān	simple; not complicated	
见面	見面	jian4mian4	jiànmiàn	meet/see somebody; meeting	
健康	健康	jian4kang1	jiànkāng	health; healthy	
讲	講	jiang3	jiǎng	to talk; to lecture; to explain; a speech	
教	教	jiao1, jiao4	jiāo, jiào	teach; instruct | religion; teaching	
角	角	jiao3, jue2	jiǎo, jué	horn; angle; unit of money (1/10 yuan); corner (Kangxi radical 148) | role (theater)	
脚	腳	jiao3	jiǎo	foot (body part)	
接	接	jie1	jiē	connect; to meet; to pick up (somebody); to receive	
街道	街道	jie1dao4	jiēdào	street	
节目	節目	jie2mu4	jiémù	program; item (on a program)	
节日	節日	jie2ri4	jiérì	holiday; festival	
结婚	結婚	jie2hun1	jiéhūn	get married	
结束	結束	jie2shu4	jiéshù	to end; to finish; conclude	
解决	解決	jie3jue2	jiějué	settle (a dispute); resolve; solve	
借	借	jie4	jiè	lend; borrow; excuse	
经常	經常	jing1chang2	jīngcháng	often; frequently; daily	
经过	經過	jing1guo4	jīngguò	to pass; go through; as a result of	
经理	經理	jing1li3	jīnglǐ	manager; director	
久	久	jiu3	jiǔ	long (time)	
旧	舊	jiu4	jiù	old; past; used	
句子	句子	ju4zi5	jùzi	sentence	
决定	決定	jue2ding4	juédìng	decide; resolve	
可爱	可愛	ke3'ai4	kě'ài	cute; lovely	
渴	渴	ke3	kě	thirsty	
刻	刻	ke4	kè	quarter (hour); (mw for short time intervals); carve; to cut	
客人	客人	ke4ren2	kèrén	guest; customer	
空调	空調	kong1tiao2	kōngtiáo	air conditioning	
口	口	kou3	kǒu	mouth (Kangxi radical 30)	
哭	哭	ku1	kū	cry; weep	
裤子	褲子	ku4zi5	kùzi	pants; trousers	
筷子	筷子	kuai4zi5	kuàizi	chopsticks	
蓝	藍	lan2	lán	blue	
老	老	lao3	lǎo	old; aged; tough; often (Kangxi radical 125)	
离开	離開	li2kai1	líkāi	leave; depart	
礼物	禮物	li3wu4	lǐwù	gift; present	
历史	歷史	li4shi3	lìshǐ	history	
脸	臉	lian3	liǎn	face	
练习	練習	lian4xi2	liànxí	practice; exercise	
辆	輛	liang4	liàng	(mw for vehicles)	
聊天	聊天	liao2tian1	liáotiān	to chat	
了解	了解	liao3jie3	liǎojiě	comprehend; understand; know; find out	
邻居	鄰居	lin2ju1	línjū	neighbor	
留学	留學	liu2xue2	liúxué	study abroad	
楼	樓	lou2	lóu	story; floor; (multi-story) building	
绿	綠	lv4	lǜ	green	
马	馬	ma3	mǎ	horse (Kangxi radical 187)	
马上	馬上	ma3shang4	mǎshàng	at once; immediately; right away	
满意	滿意	man3yi4	mǎnyì	satisfied; pleased	
帽子	帽子	mao4zi5	màozi	hat; cap	
米	米	mi3	mǐ	rice; meter (Kangxi radical 119)	
面包	面包	mian4bao1	miànbāo	bread	
明白	明白	ming2bai5	míngbai	clear; obvious; understand; explicit	
拿	拿	na2	ná	carry in your hand; seize; to catch	
奶奶	奶奶	nai3nai5	nǎinai	grandma; (informal) paternal grandmother	
南	南	nan2	nán	South	
难	難	nan2	nán	difficult	
难过	難過	nan2guo4	nánguò	be grieved; be sad; have a hard time	
年级	年級	nian2ji2	niánjí	grade; year (in school)	
年轻	年輕	nian2qing1	niánqīng	young	
鸟	鳥	niao3	niǎo	bird (Kangxi radical 196)	
努力	努力	nu3li4	nǔlì	to work hard; to strive	
爬山	爬山	pa2shan1	páshān	mountain climbing	
盘子	盤子	pan2zi5	pánzi	plate; dish; tray	
胖	胖	pang4	pàng	fat; plump	
皮鞋	皮鞋	pi2xie2	píxié	leather shoes	
啤酒	啤酒	pi2jiu3	píjiǔ	beer	
瓶子	瓶子	ping2zi5	píngzi	bottle	
其实	其實	qi2shi2	qíshí	actually; in fact	
其他	其他	qi2ta1	qítā	other; else	
奇怪	奇怪	qi2guai4	qíguài	strange; odd	
骑	騎	qi2	qí	to ride (an animal or bike); to sit astride	
起飞	起飛	qi3fei1	qǐfēi	take off (in an airplane); liftoff	
起来	起來	qi3lai5	qǐlai	(beginning or continuing an action); to rise; get up (from bed)	
清楚	清楚	qing1chu5	qīngchu	clear; distinct; be clear about	
请假	請假	qing3jia4	qǐngjià	to ask for time off	
秋	秋	qiu1	qiū	autumn; fall; harvest time	
裙子	裙子	qun2zi5	qúnzi	skirt	
然后	然后	ran2hou4	ránhòu	then; afterwards	
热情	熱情	re4qing2	rèqíng	cordial; warm; enthusiastic	
认为	認為	ren4wei2	rènwéi	believe; think that	
认真	認真	ren4zhen1	rènzhēn	serious; earnest; take seriously	
容易	容易	rong2yi4	róngyì	easy; likely; liable (to)	
如果	如果	ru2guo3	rúguǒ	if; in the event that	
伞	傘	san3	sǎn	umbrella; parasol	
上网	上網	shang4wang3	shàngwǎng	to surf the web; to go online	
生气	生氣	sheng1qi4	shēngqì	angry; mad	
声音	聲音	sheng1yin1	shēngyīn	sound; voice	
世界	世界	shi4jie4	shìjiè	world	
试	試	shi4	shì	to try; to test; examination	
瘦	瘦	shou4	shòu	thin; tight; lean	
叔叔	叔叔	shu1shu5	shūshu	(informal) father's younger brother; uncle	
舒服	舒服	shu1fu5	shūfu	comfortable; feeling well	
树	樹	shu4	shù	tree	
数学	數學	shu4xue2	shùxué	mathematics	
刷牙	刷牙	shua1ya2	shuāyá	brush one's teeth	
双	雙	shuang1	shuāng	two; double; (mw for pairs)	
水平	水平	shui3ping2	shuǐpíng	level; standard; horizontal	
司机	司機	si1ji1	sījī	driver; chauffeur	
太阳	太陽	tai4yang2	tàiyáng	the sun	
特别	特別	te4bie2	tèbié	special; especially; particular	
疼	疼	teng2	téng	ache; sore; (it) hurts; love fondly	
提高	提高	ti2gao1	tígāo	to raise; heighten; improve	
体育	體育	ti3yu4	tǐyù	physical training; sports	
甜	甜	tian2	tián	sweet	
条	條	tiao2	tiáo	strip; (mw for long thin objects); item	
同事	同事	tong2shi4	tóngshì	colleague; co-worker	
同意	同意	tong2yi4	tóngyì	agree; to consent; approve	
头发	頭發	tou2fa5	tóufa	hair (on the head)	
突然	突然	tu1ran2	tūrán	sudden; abrupt	
图书馆	圖書館	tu2shu1guan3	túshūguǎn	library	
腿	腿	tui3	tuǐ	leg	
完成	完成	wan2cheng2	wánchéng	to complete; accomplish; to fulfill	
碗	碗	wan3	wǎn	bowl; cup	
万	萬	wan4	wàn	ten thousand	
忘记	忘記	wang4ji4	wàngjì	forget	
为	為	wei4	wèi	for; because of; to; for the sake of	
为了	為了	wei4le5	wèile	in order to; for the sake of; for the purpose of	
位	位	wei4	wèi	position; location; (polite mw for people)	
文化	文化	wen2hua4	wénhuà	culture; civilization	
西	西	xi1	xī	West (Kangxi radical 146)	
习惯	習慣	xi2guan4	xíguàn	habit; be accustomed to; usual practice	
洗手间	洗手間	xi3shou3jian1	xǐshǒujiān	toilet; lavatory; washroom	
洗澡	洗澡	xi3zao3	xǐzǎo	bathe; take a bath or shower; bath or shower	
夏	夏	xia4	xià	summer	
先	先	xian1	xiān	first; early; before	
相信	相信	xiang1xin4	xiāngxìn	believe (sb.); be convinced of	
香蕉	香蕉	xiang1jiao1	xiāngjiāo	banana	
向	向	xiang4	xiàng	direction; towards; to turn; to face	
像	像	xiang4	xiàng	be like; resemble; appearance; appear	
小心	小心	xiao3xin1	xiǎoxīn	be careful	
校长	校長	xiao4zhang3	xiàozhǎng	principal (of school, college or university); president; headmaster	
新闻	新聞	xin1wen2	xīnwén	news	
新鲜	新鮮	xin1xian1	xīnxiān	fresh (experience, food, etc.); new; novel	
信用卡	信用卡	xin4yong4ka3	xìnyòngkǎ	credit card	
行李箱	行李箱	xing2li3xiang1	xínglǐxiāng	trunk; suitcase	
熊猫	熊貓	xiong2mao1	xióngmāo	panda	
需要	需要	xu1yao4	xūyào	to need; to want; to demand	
选择	選擇	xuan3ze2	xuǎnzé	select; to pick; choose	
要求	要求	yao1qiu2	yāoqiú	to request; to demand; requirement	
爷爷	爺爺	ye2ye5	yéye	(informal) father's father; paternal grandfather	
一般	一般	yi4ban1	yìbān	general; ordinary; common; same	
一边	一邊	yi4bian1	yìbiān	one side; on the one hand; at the same time	
一定	一定	yi2ding4	yídìng	surely; certainly; necessarily; definite	
一共	一共	yi2gong4	yígòng	altogether; in total	
一会儿	一會兒	yi2hui4r5	yíhuìr	a while; a moment	
一样	一樣	yi2yang4	yíyàng	the same; alike; equal to	
一直	一直	yi4zhi2	yìzhí	always; all along; straight (in a straight line)	
以前	以前	yi3qian2	yǐqián	before; formerly; previous	
音乐	音樂	yin1yue4	yīnyuè	music	
银行	銀行	yin2hang2	yínháng	bank	
饮料	飲料	yin3liao4	yǐnliào	beverage; drink	
应该	應該	ying1gai1	yīnggāi	should; ought to; must	
影响	影響	ying3xiang3	yǐngxiǎng	influence; affect; effect	
用	用	yong4	yòng	to use (Kangxi radical 101)	
游戏	游戲	you2xi4	yóuxì	game; play; recreation	
有名	有名	you3ming2	yǒumíng	famous; well-known	
又	又	you4	yòu	(once) again; also; both (Kangxi radical 29)	
遇到	遇到	yu4dao4	yùdào	to meet; run into; come across	
元	元	yuan2	yuán	Chinese monetary unit; dollar; first; principal	
愿意	願意	yuan4yi4	yuànyì	be willing; want to; be ready	
月亮	月亮	yue4liang5	yuèliang	the moon	
越	越	yue4	yuè	even more; the more; exceed	
站	站	zhan4	zhàn	stand; a station; be on one's feet; service center	
张	張	zhang1	zhāng	(mw for flat objects); to spread out; (common surname)	
长	長	chang2, zhang3	cháng, zhǎng	long; length | grow; chief (Kangxi radical 168)
着急	著急	zhao2ji2	zháojí	to worry; feel anxious	
照顾	照顧	zhao4gu5	zhàogu	take care of; look after; give consideration	
照片	照片	zhao4pian4	zhàopiàn	picture; photograph	
照相机	照相機	zhao4xiang4ji1	zhàoxiàngjī	camera	
只	隻	zhi1, zhi3	zhī, zhǐ	but; only; merely; just | (mw for birds and certain animals)	
只有	隻有	zhi3you3	zhǐyǒu	only	
才	才	cai2	cái	ability; talent; just now; not until	
中间	中間	zhong1jian1	zhōngjiān	center; middle; between; among	
中文	中文	Zhong1wen2	Zhōngwén	Chinese (language)	
终于	終於	zhong1yu2	zhōngyú	at last; in the end; finally	
种	種	zhong3	zhǒng	type; breed; race; seed	
重要	重要	zhong4yao4	zhòngyào	important; significant; major	
周末	周末	zhou1mo4	zhōumò	weekend	
主要	主要	zhu3yao4	zhǔyào	main; principal; major	
注意	注意	zhu4yi4	zhùyì	pay attention to; take notice of; be careful	
自己	自己	zi4ji3	zìjǐ	oneself; self	
自行车	自行車	zi4xing2che1	zìxíngchē	bike; bicycle	
总是	總是	zong3shi4	zǒngshì	always; eventually	
嘴	嘴	zui3	zuǐ	mouth	
最后	最后	zui4hou4	zuìhòu	last; final; ultimately	
最近	最近	zui4jin4	zuìjìn	recently; lately; these days	
作业	作業	zuo4ye4	zuòyè	school assignment; homework; task	`;
